/**
 * @param {string} str
 * @param {{ executableScripts?: boolean }} [options]
 * @return {Node[]}
 */
export function parseHtml(str, options = {}) {
  const tmp = document.implementation.createHTMLDocument('')
  tmp.body.innerHTML = str
  const nodes = [...tmp.body.childNodes]
  if (options.executableScripts !== true) {
    return nodes
  }

  return nodes.map(cloneNodeWithExecutableScripts).filter((node) => node !== null)
}

/**
 * @param {Node} node
 * @return {Node|null}
 */
function cloneNodeWithExecutableScripts(node) {
  if (node.nodeType !== 1) {
    return node.cloneNode(true)
  }

  const element = /** @type {HTMLElement} */ (node)
  const tagName = element.tagName.toLowerCase()
  if (tagName === 'noscript') {
    return null
  }

  if (tagName === 'script') {
    return cloneScriptNode(element)
  }

  const clone = element.cloneNode(false)
  element.childNodes.forEach((childNode) => {
    const clonedChild = cloneNodeWithExecutableScripts(childNode)
    if (clonedChild) {
      clone.appendChild(clonedChild)
    }
  })
  return clone
}

/**
 * @param {HTMLScriptElement} sourceScript
 * @return {HTMLScriptElement}
 */
function cloneScriptNode(sourceScript) {
  const targetScript = document.createElement('script')
  Array.from(sourceScript.attributes).forEach((attribute) => {
    targetScript.setAttribute(attribute.name, attribute.value)
  })

  if (sourceScript.textContent) {
    targetScript.textContent = sourceScript.textContent
  }

  return targetScript
}
